module.exports = __webpack_public_path__ + "index_assets/img/report_sample.5ead55f5.jpg";